import { $ as jquery } from 'jquery';

var $ = jquery;
var pluses = /\+/g;

function isFunction(value) {
  return typeof value === 'function';
}

function encode(value) {
  return cookie.raw ? String(value) : encodeURIComponent(String(value));
}

function decode(value) {
  return cookie.raw ? String(value) : decodeURIComponent(String(value));
}

function stringifyCookieValue(value) {
  var normalized = cookie.json ? JSON.stringify(value) : String(value);
  return encode(normalized);
}

function parseCookieValue(value) {
  if (value.indexOf('"') === 0) {
    value = value.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
  }

  try {
    value = decodeURIComponent(value.replace(pluses, ' '));
    return cookie.json ? JSON.parse(value) : value;
  } catch {
    return undefined;
  }
}

function read(value, converter) {
  var result = cookie.raw ? value : parseCookieValue(value);
  return isFunction(converter) ? converter(result) : result;
}

function cookie(key, value, options) {
  if (value !== undefined && !isFunction(value)) {
    options = $.extend({}, cookie.defaults, options);

    if (typeof options.expires === 'number') {
      var days = options.expires;
      var expires = new Date();
      expires.setTime(expires.getTime() + days * 864e5);
      options.expires = expires;
    }

    document.cookie = [
      encode(key),
      '=',
      stringifyCookieValue(value),
      options.expires ? '; expires=' + options.expires.toUTCString() : '',
      options.path ? '; path=' + options.path : '',
      options.domain ? '; domain=' + options.domain : '',
      options.secure ? '; secure' : '',
      options.sameSite ? '; samesite=' + options.sameSite : '',
    ].join('');

    return document.cookie;
  }

  var result = key ? undefined : {};
  var cookies = document.cookie ? document.cookie.split('; ') : [];

  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split('=');
    var name = decode(parts.shift());
    var cookieValue = parts.join('=');

    if (key && key === name) {
      result = read(cookieValue, value);
      break;
    }

    if (!key) {
      var parsed = read(cookieValue);
      if (parsed !== undefined) {
        result[name] = parsed;
      }
    }
  }

  return result;
}

cookie.defaults = {};
cookie.raw = false;
cookie.json = false;

$.cookie = cookie;
$.removeCookie = function (key, options) {
  if (cookie(key) === undefined) {
    return false;
  }
  cookie(key, '', $.extend({}, options, { expires: -1 }));
  return cookie(key) === undefined;
};

if (typeof window !== 'undefined') {
  if (window.jQuery) {
    window.jQuery.cookie = cookie;
    window.jQuery.removeCookie = $.removeCookie;
  }
  if (window.$) {
    window.$.cookie = cookie;
    window.$.removeCookie = $.removeCookie;
  }
}

export { cookie };
